var UtilFunction = /** @class */ (function () {
    function UtilFunction() {
        this.negate = function (callback) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return !callback.apply(callback, args);
            };
        };
    }
    return UtilFunction;
}());
export var utilFunction = new UtilFunction();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilFunction.ts
// module id = 594
// module chunks = 3